import { combineReducers } from 'redux';

import { reducers as loginReducers } from '../components/login';
import { reducers as commonReducers } from '../components/common';
import { reducers as mylibraryReducers } from '../components/mylibrary';
import { reducers as testTemplateReducer } from '../components/test-template';
import { reducers as userManagementReducer } from '../components/user-management';
import { reducers as userProfileReducers } from '../components/user-profile';
import { reducers as tagManagementReducers } from '../components/tag-mangement';
import { reducers as goalManagementReducers } from '../components/goal-management';
import { reducers as dashboardReducer } from '../components/dashboard';
import { reducers as courseDataReducer } from '../components/course';
import { reducers as headerReducer } from '../components/header';
import { reducers as clientReducer } from '../components/userManagement';
import { reducers as contentRequestReducer } from '../components/content-request';
import { reducers as courseMangementReducer } from '../components/course-Management';
import questionCreate from '../components/mylibrary/reducers/questionCreateReducer';
import studyNotedReducers from '../components/mylibrary/reducers/notesReducers';
import wrapperTabsReducers from '../components/mylibrary/reducers/wrapperTabsReducers';
import showVideoModalReducers from '../components/mylibrary/reducers/showVideoModalReducers';
import videoUploadedReducers from '../components/mylibrary/reducers/videoUploadedReducers';
import videoCreateContentReducers from '../components/mylibrary/reducers/videoCreateContentReducers';
import audioCreateContentReducers from '../components/mylibrary/reducers/audioCreateContentReducers';
import videoDetailsInContentReducers from '../components/mylibrary/reducers/addDetailsVideoReducer';
import audioDetailsInContentReducers from '../components/mylibrary/reducers/addDetailsAudioReducer';
import videoDetailsReducers from '../components/mylibrary/reducers/videoDetailsReducers';
import studyMaterialReducer from '../components/mylibrary/reducers/notesStateReducers';
import { reducers as contentRequestReducers } from '../components/content-request/'
import importReducer from '../components/mylibrary/reducers/bulkimportReducer';
import coursePlanStatesReducers from '../components/course-Management/reducers/coursePlanReducer';
import createCoursePlanReducer from '../components/course-Management/reducers/createCoursePlanReducer';
import showProgressModalReducers from '../components/mylibrary/reducers/showProgressModalReducer';
import conceptAddReducer from '../components/mylibrary/reducers/conceptUpdateReducers';
import remedialQuestionReducer from '../components/mylibrary/reducers/remedialQuestionReducer';

const rootReducer = combineReducers({
    loginData: loginReducers,
    commonData: commonReducers,
    mylibraryData: mylibraryReducers,
    testTemplate: testTemplateReducer,
    courseData: courseDataReducer,
    contentRequestData: contentRequestReducer,
    courseMangementData: courseMangementReducer,
    userManagement: userManagementReducer,
    clientManagement: clientReducer,
    userProfileData: userProfileReducers,
    tagManagementData: tagManagementReducers,
    goalManagement: goalManagementReducers,
    dashboardData: dashboardReducer,
    header: headerReducer,
    questionCreate,
    studyNotedReducers,
    videoDetailsInContentReducers,
    audioDetailsInContentReducers,
    videoDetailsReducers,
    wrapperTabsReducers,
    showVideoModalReducers,
    videoUploadedReducers,
    videoCreateContent: videoCreateContentReducers,
    audioCreateContent: audioCreateContentReducers,
    studyMaterialReducer,
    contentRequestReducer,
    bulkImportCount : importReducer,
    coursePlanStates: coursePlanStatesReducers,
    createCoursePlanStates: createCoursePlanReducer,
    showProgressModalReducers,
    conceptAddReducer,
    remedialQuestionReducer
});

export default rootReducer;